"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Loader, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage, FormDescription } from "@/components/ui/form";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
export default function NewsletterSubscription() {
  return;
}
function NewsletterForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex items-center gap-3 p-4 bg-primary/10 border border-primary/20 rounded-md text-primary animate-in fade-in slide-in-from-bottom-2">
        <Check className="size-5 shrink-0" />
        <p className="font-medium">{successMessage}</p>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-4">
      {}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <FormField control={control} name="first_name" render={({
        field
      }) => <FormItem>
              <FormLabel className="sr-only">First Name</FormLabel>
              <FormControl>
                <input {...field} placeholder="First Name" className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 transition-all" />
              </FormControl>
              <FormMessage />
            </FormItem>} />
        <FormField control={control} name="last_name" render={({
        field
      }) => <FormItem>
              <FormLabel className="sr-only">Last Name</FormLabel>
              <FormControl>
                <input {...field} placeholder="Last Name" className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 transition-all" />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      {}
      <FormField control={control} name="topics" render={({
      field
    }) => <FormItem>
            <div className="flex flex-wrap gap-4 py-1">
              {["Latest Projects", "Research & Innovation", "Events & Webinars"].map((topic, i) => <label key={topic} data-index={i} className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground cursor-pointer group">
                  <input type="checkbox" checked={field.value?.includes(topic)} onChange={e => {
            const checked = e.target.checked;
            const current = field.value || [];
            if (checked) {
              field.onChange([...current, topic]);
            } else {
              field.onChange(current.filter((val: string) => val !== topic));
            }
          }} className="appearance-none h-4 w-4 shrink-0 rounded-sm border border-input bg-background ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 checked:bg-primary checked:border-primary checked:text-primary-foreground relative after:content-[''] after:absolute after:text-white after:text-[10px] after:top-1/2 after:left-1/2 after:-translate-x-1/2 after:-translate-y-1/2 after:opacity-0 checked:after:opacity-100 transition-all" />
                  <span className="group-hover:underline decoration-primary/50 underline-offset-4 transition-all">
                    {topic}
                  </span>
                </label>)}
            </div>
            <FormMessage />
          </FormItem>} />

      {}
      <div className="flex items-start">
        <FormField control={control} name="email" rules={{
        required: "Email is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Invalid email address"
        }
      }} render={({
        field
      }) => <FormItem className="flex-1 relative">
              <FormLabel className="sr-only">Email Address</FormLabel>
              <FormControl>
                <input {...field} type="email" placeholder="you@example.com" className="flex h-12 w-full rounded-l-md rounded-r-none border border-input border-r-0 bg-background px-4 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 transition-all z-10 relative" />
              </FormControl>
              <FormMessage className="absolute -bottom-6 left-0" />
            </FormItem>} />
        <Button type="submit" disabled={isSubmitting} className="h-12 rounded-l-none rounded-r-md px-8 bg-primary text-primary-foreground hover:bg-primary/90 shadow-none border border-primary">
          {isSubmitting ? <Loader className="animate-spin size-4" /> : "Subscribe"}
        </Button>
      </div>

      {submitError && <p className="text-sm text-destructive mt-2">{submitError}</p>}
    </Form>;
}